import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import {
    Typography,
    styled,
    Divider,
    Box,
    Badge,
    Avatar,
    Skeleton,
} from '@mui/material';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import { formatDistanceToNow } from 'date-fns';

import Title from '../Navbar/Title';

const StyledNotification = styled('div')(({ theme }) => ({
    backgroundColor: '#fff',
    padding: '10px',
    marginBottom: '10px',
    borderRadius: '4px',
    display: 'flex',
    gap: '14px',
}));

const TimeAgo = ({ timestamp }) => {
    const formattedTime = formatDistanceToNow(new Date(timestamp), {
        addSuffix: true,
    });

    return <span>{formattedTime}</span>;
};

const Notif = ({ notification }) => {
    return (
        <StyledNotification>
            <Box>
                <Badge
                    overlap="circular"
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    badgeContent={
                        notification.type !== 'event' ? (
                            <GroupsRoundedIcon
                                sx={{
                                    background: '#06D9FA',
                                    color: '#fff',
                                    padding: '3px',
                                    display: 'none',
                                    borderRadius: '25px',
                                }}
                            />
                        ) : (
                            <ScheduleRoundedIcon
                                sx={{
                                    background: '#06D9FA',
                                    color: '#fff',
                                    padding: '3px',
                                    display: 'none',
                                    borderRadius: '25px',
                                }}
                            />
                        )
                    }
                >
                    {notification.type !== 'event' ? (
                        <GroupsRoundedIcon
                            sx={{
                                background: '#06D9FA',
                                color: '#fff',
                                fontSize: '3rem',
                                padding: '3px',
                                borderRadius: '25px',
                            }}
                        />
                    ) : (
                        <ScheduleRoundedIcon
                            sx={{
                                background: '#06D9FA',
                                color: '#fff',
                                fontSize: '3rem',
                                padding: '3px',
                                borderRadius: '25px',
                            }}
                        />
                    )}
                </Badge>
            </Box>
            <Box>
                {notification.title !== undefined && (
                    <Typography sx={{ fontWeight: '700' }}>
                        {notification.title}
                    </Typography>
                )}

                {notification.subject !== undefined && (
                    <Typography>
                        {notification.subject.replace(
                            /(<|&lt;)br\s*\/*(>|&gt;)/g,
                            ' '
                        )}
                    </Typography>
                )}
                {notification.body !== undefined && (
                    <Typography>
                        {notification.body.replace(
                            /(<|&lt;)br\s*\/*(>|&gt;)/g,
                            ' '
                        )}
                    </Typography>
                )}

                <Typography>
                    <TimeAgo timestamp={notification.createdAt} />
                </Typography>
            </Box>
        </StyledNotification>
    );
};
const NotificationList = props => {
    const { getAccessTokenSilently } = useAuth0();

    let [notification, setNotification] = useState({});
    let [loading, setLoading] = useState(false);

    useEffect(async () => {
        setLoading(true);
        try {
            const token = await getAccessTokenSilently({
                scope: process.env.REACT_APP_scope,
            });

            notification = await axios.get('/getMyNotifications', {
                baseURL: process.env.REACT_APP_API_GATEWAY,
                url: `/getMyNotifications`,
                timeout: 30000,
                headers: {
                    authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            setNotification(notification.data);
        } finally {
            setLoading(false);
        }
    }, []);

    return (
        <div>
            <Title title={' Notifications'} />
            <br />
            <Divider textAlign="left" sx={{ display: 'none' }}>
                <Typography
                    sx={{
                        fontSize: '1.5rem',
                        fontWeight: '700',
                        lineHeight: '1.1667',
                        margin: '8px 5px',
                    }}
                >
                    Notifications
                </Typography>
            </Divider>
            <br />
            {loading ? (
                <>
                    {Array.from({ length: 4 }).map((_, index) => (
                        <div key={index}>
                            <Skeleton
                                animation="wave"
                                height={100}
                                sx={{ mx: ' 14px' }}
                            />
                        </div>
                    ))}
                </>
            ) : (
                <>
                    {notification?.Message?.Success === true ? (
                        <>
                            {notification?.Message?.Data.map(
                                (notificationItem, index) => (
                                    <Notif
                                        key={index}
                                        notification={notificationItem}
                                    />
                                )
                            )}
                        </>
                    ) : (
                        <>
                            <Typography
                                variant="h6"
                                sx={{ textAlign: 'center' }}
                            >
                                No Notifications Received
                            </Typography>
                            <Typography
                                variant="h6"
                                sx={{ textAlign: 'center' }}
                            >
                                <br />
                                <NotificationsActiveIcon
                                    sx={{ fontSize: '6rem', opacity: '.2' }}
                                />
                            </Typography>
                        </>
                    )}
                </>
            )}
        </div>
    );
};

export default NotificationList;
